module.exports = "//static.hsappstatic.net/salesImages/static-1.403/wizards/join-connect-getstarted/getstarted.svg"